import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BookOpen, Clock } from "@phosphor-icons/react";

export default function Academy() {
  const [courses, setCourses] = useState([]);

  useEffect(() => { api.get("/knowledge").then((r) => setCourses(r.data)); }, []);

  const cats = [...new Set(courses.map((c) => c.category))];

  return (
    <div className="space-y-10" data-testid="academy-page">
      <header>
        <p className="overline text-saffron mb-2">Vansha Academy</p>
        <h1 className="font-serif font-semibold text-4xl sm:text-5xl">Knowledge, gently.</h1>
        <p className="text-ink-700 mt-2 max-w-2xl">Rigorous, doctor-reviewed guidance. Read at your pace. Save for the moment you need it.</p>
      </header>

      {cats.map((cat) => (
        <section key={cat} data-testid={`category-${cat}`}>
          <h2 className="font-serif text-2xl mb-6">{cat}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.filter((c) => c.category === cat).map((c) => (
              <Link to={`/app/academy/${c.id}`} key={c.id} className="vansha-card overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all" data-testid={`course-${c.id}`}>
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={c.cover} alt={c.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <p className="overline text-saffron mb-2">{c.category}</p>
                  <h3 className="font-serif text-2xl leading-tight">{c.title}</h3>
                  <p className="text-sm text-ink-700 mt-2">{c.subtitle}</p>
                  <div className="flex items-center gap-4 mt-4 text-xs text-ink-500">
                    <span className="flex items-center gap-1"><BookOpen weight="thin" size={14} />{c.lessons} lessons</span>
                    <span className="flex items-center gap-1"><Clock weight="thin" size={14} />{c.duration}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
